module.exports = __webpack_public_path__ + "media/conferencia.05a43f96.mp3";